import * as React from 'react';

const TreeViewContext = React.createContext({});

export default TreeViewContext;
